export const generateBaseStyles = ({ colors = {}, dimensions = {}, fontFamily = 'arial', buttonStyle = 'icons', fontSize = { value: 1, unit: 'rem' }, textAlign, fontSpacing = {
    letterSpacing: { value: 0, unit: 'px' },
    lineHeight: { value: 1.5, unit: 'em' },
    wordSpacing: { value: 0, unit: 'px' }
} }) => `
/* Font imports */
${fontFamily === 'poppins' ? "@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');" :
        fontFamily === 'roboto' ? "@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');" : ''}

.radio-player {
    font-family: ${fontFamily === 'poppins' ? "'Poppins'" : fontFamily === 'roboto' ? "'Roboto'" : "'Arial'"}, sans-serif;
    position: relative;
    width: ${dimensions?.width || '300px'};
    height: ${dimensions?.height || 'auto'};
    background: ${colors?.background || 'rgba(0, 0, 0, 0.8)'};
    border-radius: ${dimensions?.borderRadius || '8px'};
    border: ${dimensions?.borderSize || '0px'} solid ${colors?.background || 'rgba(0, 0, 0, 0.8)'};
    padding: ${dimensions?.padding || '15px'};
    margin: ${dimensions?.margin || '10px'};
    box-sizing: border-box;
    box-shadow: ${(() => {
        if (!colors?.backgroundShadow) return 'none';
        const angle = colors?.backgroundShadowAngle || 135;
        const blur = colors?.backgroundShadowBlur || 15;
        const offset = colors?.backgroundShadowOffset || 4;
        const angleRad = (angle * Math.PI) / 180;
        const x = Math.cos(angleRad) * offset;
        const y = Math.sin(angleRad) * offset;
        return `${x}px ${y}px ${blur}px ${colors.backgroundShadow}`;
    })()};
    color: ${colors?.text || 'white'};
    overflow: hidden;
}

.player-content {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.album-artwork {
    width: 100%;
    aspect-ratio: 1;
    position: relative;
    overflow: hidden;
}

.artwork-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.artwork-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(51, 51, 51, 0.2);
    color: ${colors?.text || 'white'};
}

.time-bar-container {
    width: 100%;
    padding: 5px 0;
    position: relative;
}

.time-bar {
    width: 100%;
    height: 4px;
    background: ${colors?.timeBar ? `${colors.timeBar}33` : 'transparent'};
    border-radius: 2px;
    overflow: hidden;
    position: relative;
}

.time-bar-progress {
    height: 100%;
    background: ${colors?.timeBar || '#333333'};
    width: 0;
    border-radius: 2px;
    transition: width 0.1s linear;
}

.time-info {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    font-size: 12px;
    color: ${colors?.text || 'white'} !important;
    width: 100%;
}

.elapsed-time {
    text-align: left;
}

.duration-time {
    text-align: right;
}

.station-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 0;
}

.radio-name {
    font-size: 12px;
    font-weight: 600;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.live-container {
    display: flex;
    align-items: center;
    gap: 5px;
}

.live-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${colors?.liveIndicator || '#FF0000'};
    animation: pulse 2s infinite;
}

.live-text {
    font-size: 12px;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.song-info {
    width: 100%;
    padding: 15px 0;
    text-align: ${textAlign || 'left'};
}

.song-name {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.artist-name {
    font-size: 12px;
    opacity: 0.8;
    color: ${colors?.text || 'white'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.controls-container {
    position: relative;
    width: 100%;
}

.controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${buttonStyle === 'text' ? '20px' : '30px'};
    padding: 15px 20px;
}

.control-button {
    background: ${buttonStyle === 'text' || buttonStyle === 'icons' ? 'transparent' : colors?.buttonBackground || 'none'};
    border: none;
    color: ${colors?.icon || 'white'} !important;
    cursor: pointer;
    padding: ${buttonStyle === 'text' ? '0.5rem 0.75rem' : buttonStyle === 'icons' ? '0.25rem' : '0.5rem'};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${buttonStyle === 'text' ? '0.9rem' : '1rem'};
    font-weight: ${buttonStyle === 'text' ? '500' : 'normal'};
    box-shadow: ${(() => {
        if (!colors?.buttonShadow || buttonStyle === 'text' || buttonStyle === 'icons') return 'none';
        const angle = colors?.buttonShadowAngle || 135;
        const blur = colors?.buttonShadowBlur || 4;
        const offset = colors?.buttonShadowOffset || 2;
        const angleRad = (angle * Math.PI) / 180;
        const x = Math.cos(angleRad) * offset;
        const y = Math.sin(angleRad) * offset;
        return `${x}px ${y}px ${blur}px ${colors.buttonShadow}`;
    })()};
    border-radius: ${(() => {
        switch (buttonStyle) {
            case 'circle': return '50%';
            case 'square': return '4px';
            case 'rounded': return '20px';
            case 'text':
            case 'icons':
                return '0';
            default: return '50%';
        }
    })()};
    min-width: ${buttonStyle === 'text' ? '60px' : buttonStyle === 'circle' || buttonStyle === 'square' ? '36px' : 'auto'};
    width: ${buttonStyle === 'circle' || buttonStyle === 'square' ? '36px' : 'auto'};
    height: ${buttonStyle === 'circle' || buttonStyle === 'square' ? '36px' : 'auto'};
    aspect-ratio: ${buttonStyle === 'circle' || buttonStyle === 'square' ? '1' : 'auto'};
    text-transform: ${buttonStyle === 'text' ? 'uppercase' : 'none'};
    transition: color 0.1s ease;
}

.control-button:hover {
    color: ${colors?.accent || colors?.icon || 'white'} !important;
}

.volume-bar-container {
    position: absolute;
    bottom: calc(100% + 5px);
    left: 50%;
    transform: translate(170%, 15px);
    background: ${colors?.background || 'rgba(0, 0, 0, 0.9)'};
    padding: 12px 8px;
    border-radius: ${dimensions?.borderRadius || '12px'};
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
    z-index: 100;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: default;
    height: 100px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.volume-bar-container:before {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${colors?.background || 'rgba(0, 0, 0, 0.9)'};
}

.volume-bar-container.show {
    opacity: 1;
    visibility: visible;
}

.volume-slider {
    -webkit-appearance: none !important;
    appearance: none !important;
    width: 80px !important;
    height: 4px !important;
    background: ${colors?.timeBar ? `${colors.timeBar}40` : 'rgba(255, 255, 255, 0.2)'} !important;
    border-radius: 2px !important;
    outline: none !important;
    transform: rotate(-90deg) !important;
    transform-origin: center !important;
    margin: 0 !important;
    cursor: pointer !important;
    position: absolute !important;
    border: none !important;
    box-shadow: none !important;
}

.volume-slider::-webkit-slider-thumb {
    -webkit-appearance: none !important;
    appearance: none !important;
    width: 12px !important;
    height: 12px !important;
    background: ${colors?.timeBar || '#ffffff'} !important;
    border-radius: 50% !important;
    cursor: pointer !important;
    transition: transform 0.2s ease !important;
    transform-origin: center !important;
    border: none !important;
    margin-top: -4px !important;
    box-shadow: none !important;
}

.volume-slider::-moz-range-thumb {
    width: 12px !important;
    height: 12px !important;
    background: ${colors?.timeBar || '#ffffff'} !important;
    border-radius: 50% !important;
    cursor: pointer !important;
    transition: transform 0.2s ease !important;
    transform-origin: center !important;
    border: none !important;
    margin-top: -4px !important;
    box-shadow: none !important;
}

.volume-slider::-webkit-slider-runnable-track {
    height: 4px !important;
    border-radius: 2px !important;
    background: inherit !important;
    border: none !important;
    box-shadow: none !important;
}

.volume-slider::-moz-range-track {
    height: 4px !important;
    border-radius: 2px !important;
    background: inherit !important;
    border: none !important;
    box-shadow: none !important;
}

.volume-slider::-webkit-slider-thumb:hover {
    transform: scale(1.2) !important;
}

.volume-slider::-moz-range-thumb:hover {
    transform: scale(1.2) !important;
}

.volume-button:hover .volume-bar-container,
.volume-bar-container:hover {
    opacity: 1;
    visibility: visible;
}

/* History Modal Styles */
.history-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
}

.history-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10000;
}

.history-modal-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${colors?.historyModalBg || colors?.background || '#1e1e1e'};
    padding: 1.45rem;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    z-index: 10001;
    max-width: 500px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
    font-family: ${fontFamily === 'poppins' ? "'Poppins'" : fontFamily === 'roboto' ? "'Roboto'" : "'Arial'"}, sans-serif;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
}

/* WebKit scrollbar styles */
.history-modal-content::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.history-modal-content::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 3px;
}

.history-modal-content::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
    transition: background 0.2s;
}

.history-modal-content::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
}

.history-modal-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: ${colors.historyModalTexts || colors.text || '#ffffff'} !important;
    margin: 0 0 0.97rem 0;
    padding-right: 1.45rem;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.history-modal-close {
    position: absolute;
    top: 0.97rem;
    right: 0.97rem;
    background: none;
    border: none;
    color: ${colors?.historyModalTexts || colors?.text || '#ffffff'} !important;
    cursor: pointer;
    padding: 0.387rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
}

.history-modal-close:hover {
    background: rgba(255, 255, 255, 0.1);
}

.history-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.history-item {
    display: flex;
    gap: 1rem;
    align-items: center;
    padding: 0.5rem;
    border-radius: 8px;
    transition: background-color 0.2s;
}

.history-item:hover {
    background: rgba(255, 255, 255, 0.05);
}

.history-artwork {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
}

.history-artwork img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.history-song-info {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.history-song-title {
    font-size: 0.875rem;
    font-weight: 500;
    color: ${colors.historyModalTexts || colors.text || '#ffffff'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

.history-artist-name {
    font-size: 0.75rem;
    color: ${colors.historyModalTexts ? `${colors.historyModalTexts}99` : colors.text ? `${colors.text}99` : '#ffffff99'} !important;
    letter-spacing: ${fontSpacing?.letterSpacing.value}${fontSpacing?.letterSpacing.unit};
    line-height: ${fontSpacing?.lineHeight.value}${fontSpacing?.lineHeight.unit};
    word-spacing: ${fontSpacing?.wordSpacing.value}${fontSpacing?.wordSpacing.unit};
}

@keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
}

.radio-player .control-button {
    padding: 5px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
}

.radio-player .control-button.play-button {
    width: calc(36px * 1.3);
    height: calc(36px * 1.3);
    font-size: 1.5rem;
}

.radio-player .control-button .fa-play {
    margin-left: 2px;
    font-size: inherit;
}

.radio-player .control-button .fa-pause {
    font-size: inherit;
}
`; 